import { variables } from 'config';
import getTheme from 'config/themes/base';

const theme = getTheme();

export default {
  root: {
    minHeight: `calc(100vh - ${variables.headerHeight} - ${variables.footerHeight} - 40px)`,
    width: '100%',
    borderRadius: 'unset',
    backgroundColor: theme.palette.primary.mainBackground,
    color: theme.palette.primary.main,
    flexGrow: 1,
    display: 'block',
    textAlign: 'start',
    padding: '24px',
    fontFamily: 'Montserrat, sans-serif',
    fontStyle: 'normal',
    overflow: 'hidden',
  },
  tableRoot: {
    borderRadius: 'unset',
    backgroundColor: theme.palette.primary.sideBarBgColor,
    color: theme.palette.primary.main,
    flexGrow: 1,
    display: 'block',
    textAlign: 'start',
    fontFamily: 'Montserrat, sans-serif',
    fontStyle: 'normal',
  },
  container: {
    display: 'inherit',
    boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.05)',
    borderRadius: '4px',
  },
  tabsContainer: {
    flexGrow: 1,
    backgroundColor: theme.palette.primary.backgroundColor,
  },
};
